import React, { ReactNode } from "react"
import { Flex, SpaceProps, Text } from "@chakra-ui/react"
import Icon from "components/elements/Icon"

type Props = {
  children: ReactNode
  mt?: SpaceProps["marginTop"]
  ml?: SpaceProps["marginLeft"]
}

const InlineWarning = ({ children, mt = 2, ml }: Props) => (
  <Flex alignItems="center" gap={1} mt={mt} ml={ml}>
    <Icon icon="alert" color="red.500" size={5} />
    <Text color="red.500">{children}</Text>
  </Flex>
)

export default InlineWarning
